import $ from 'jquery';
window.jQuery = $;
window.$ = $;
//window.$ = window.jQuery = require('jquery')
window.Popper = require('popper.js')
require('bootstrap')
require('slick-carousel')
require('node-waves')

import scss from './scss/app.scss'

var common;
(function ($) {

  common = {
    // configuration
    _config: {
      mobileIndicatorSelector: '.navbar-toggler',
      bpXsWidth: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xs'), 10),
      bpSmWidth: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-sm'), 10),
      bpMdWidth: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'), 10),
      bpLgWidth: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg'), 10),
      bpXlWidth: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xl'), 10)
    },

    // enable debug mode
    _debug: false,

    isSmallView: function () {
      return $(common._config.mobileIndicatorSelector).is(':visible');
    },
    isBpXs: function () {
      return window.matchMedia('only screen and (max-width: '+ (common._config.bpSmWidth - 1) + 'px)').matches;
    },
    isBpSm: function () {
      return window.matchMedia('only screen and (min-width: '+ common._config.bpSmWidth + 'px) and (max-width: '+ (common._config.bpMdWidth - 1 ) + 'px)').matches;
    },
    isBpMd: function () {
      return window.matchMedia('only screen and (min-width: '+ common._config.bpMdWidth + 'px) and (max-width: '+ (common._config.bpLgWidth - 1 ) + 'px)').matches;
    },
    isBpLg: function () {
      return window.matchMedia('only screen and (min-width: '+ common._config.bpLgWidth + 'px) and (max-width: '+ (common._config.bpXlWidth - 1 ) + 'px)').matches;
    },
    isBpXl: function () {
      return window.matchMedia('only screen and (min-width: '+ (common._config.bpXlWidth) + 'px)').matches;
    },

    isMobileDevice: function () {
      var check = false;
      (function (a) {
        if (/(android|ipad|playbook|silk|bb\d+|meego).+nexus|mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)) || (( 'ontouchstart' in window ) && !( 'onmousemove' in window )) ||
          navigator.msMaxTouchPoints || navigator.userAgent.toLowerCase().match( /(windows phone os 7|linux; android)/i )) check = true
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },

    getCurrentHash: function () {
      return window.location.hash;
    },

    printDebug: function (message) {
      if (common._debug && window.console) {
        console.log(message);
      }
    },

    initPage: function () {
      $('[data-toggle="tooltip"]').tooltip();
      $('[data-toggle="popover"]').popover();
      Waves.attach('.btn');
      Waves.init()
    },

    // to help prevent comma errors after functions
    ignoreme: ''
  }
})(jQuery);


/* =============================================================================
   Document ready function
   ========================================================================== */

$(function() {
  CUSTOM.init();

  var lastScrollTop = $(window).scrollTop();

  function stickyHeader() {
    var distance = 1;
    var scrollTop = $(window).scrollTop();

    if (scrollTop >= distance) {
      $('body').addClass('sticky');
    } else {
      $('body').removeClass('sticky');
    }
    lastScrollTop = scrollTop;
  }
  $(window).on('scroll load', stickyHeader);


  $('#off-canvas').offcanvas( {
    modifiers: 'left,overlay,absolute',
    //triggerButton: '.trigger-offcanvas',
    onInit:  function() {
      $(this).removeClass('is-hidden');
    }
  });


  $('.teaser').on('init', function (event, slick) {
    if(slick.options.dots) {
      //slick.$dots.append('<li class="slide-count">' + slick.slideCount + '</li>');
      slick.$nextArrow.clone().addClass('slick-dots-next').appendTo(slick.$dots).wrap('<li class="slick-dots-arrow slick-dots-arrow-next"></li>');
      slick.$prevArrow.clone().addClass('slick-dots-prev').appendTo(slick.$dots).wrap('<li class="slick-dots-arrow slick-dots-arrow-prev"></li>');
    }
  });
  $('.teaser').on('breakpoint', function (event, slick, breakpoint) {
    if(slick.options.dots) {
      //slick.$dots.append('<li class="slide-count">' + slick.slideCount + '</li>');
      slick.$nextArrow.clone().addClass('slick-dots-next').appendTo(slick.$dots).wrap('<li class="slick-dots-arrow slick-dots-arrow-next"></li>');
      slick.$prevArrow.clone().addClass('slick-dots-prev').appendTo(slick.$dots).wrap('<li class="slick-dots-arrow slick-dots-arrow-prev"></li>');
    }
  });

  var teaserSlider = $('.teaser').slick({
    infinite: true,
    dots: true,
    arrows: false,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendArrows: $('.teaser-slide-arrows'),
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="40px" viewBox="0 0 20 40"><path d="M13.657,17.3C14.357,18,15.4,19,15.4,20s-0.943,1.899-1.743,2.7L0,35v5l18.9-17.3C19.7,21.899,20,21,20,20s-0.399-2-1.1-2.7L0,0v5L13.657,17.3z"/></svg></button>',
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="40px" viewBox="0 0 20 40"><path d="M6.343,22.7C5.643,22,4.6,21,4.6,20s0.943-1.9,1.743-2.7L20,5V0.1L1.1,17.3C0.3,18.1,0,19,0,20s0.4,2,1.1,2.7L20,40v-5L6.343,22.7z"/></svg></button>',
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          arrows: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          arrows: true
        }
      }
    ]
  });

  $('.teaser .slick-dots-next').on('click', function(e){
    e.preventDefault();
    teaserSlider.slick('slickNext');
  });
  $('.teaser .slick-dots-prev').on('click', function(e){
    e.preventDefault();
    teaserSlider.slick('slickPrev');
  });



  /* ---- viewport fix for Windows Phone IE ---- */
  if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement("style");
    msViewportStyle.appendChild(
      document.createTextNode(
        "@-ms-viewport{width:auto!important}"
      )
    );
    document.getElementsByTagName("head")[0].appendChild(msViewportStyle);
  }


});

/* =============================================================================
   CUSTOM functions
   ========================================================================== */
var CUSTOM;

(function($) {
  CUSTOM = {
    init: function() {
      common.initPage();
    },
  };
}(jQuery));